export const artiQAcceptabilityStatus = {
  ACCEPTABLE: "Acceptable",
  USABLE: "Usable",
  REJECTED: "Rejected",
};
